// src/pages/products/WiresPage.tsx
import React from 'react';
import { Button, Modal, Input, Tag } from 'antd';
import { WiresItem } from '../../types/ProductItems';
import WiresForm from '../../components/forms/WiresForm';
import WiresTable from '../../components/tables/WiresTable';
import { useProductManager } from '../../hooks/useProductManager';
import { STORE_NAMES } from '../../utils/db';

const WiresPage: React.FC = () => {
  const [search, setSearch] = React.useState('');

  const {
    items: wires,
    currentItem,
    setCurrentItem,
    isModalVisible,
    setIsModalVisible,
    addItem: handleAddWires,
    deleteItem: handleDelete,
    exportToExcel,
  } = useProductManager<WiresItem>(STORE_NAMES.wires);

  const handleEdit = (item: WiresItem) => {
    setCurrentItem(item);
    setIsModalVisible(true);
  };

  const filtered = React.useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return wires;
    return wires.filter(item =>
      [item.brand, item.partNumber, item.model, item.original, String(item.price)]
        .filter(Boolean)
        .some(v => String(v).toLowerCase().includes(q))
    );
  }, [wires, search]);

  const totalCount = wires.length;
  const shownCount = filtered.length;

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>

        <Button type="primary" onClick={() => { setIsModalVisible(true); setCurrentItem(null); }}>
          Добавить наконечник
        </Button>

        <Button onClick={() => exportToExcel('Wires_Export')}>
          📁 Экспорт в Excel
        </Button>

        <Input
          placeholder="Поиск…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: 280 }}
          allowClear
        />

        <Tag className="small-tag">Всего: {totalCount}</Tag>
        <Tag color="blue" className="small-tag">Показано: {shownCount}</Tag>

      </div>

      <WiresTable data={filtered} onEdit={handleEdit} onDelete={handleDelete} />

      <Modal
        title={currentItem ? 'Редактировать наконечник' : 'Добавить наконечник'}
        open={isModalVisible}
        onCancel={() => { setIsModalVisible(false); setCurrentItem(null); }}
        footer={null}
        destroyOnHidden
      >
        <WiresForm onAdd={handleAddWires} initialValues={currentItem} />
      </Modal>
    </div>
  );
};

export default WiresPage;
